import "../Purchasing/Purchasing.css";
import "./BuyNow.css";
import icon9 from "../Icons/Icon-09.png";
import { showRegister } from "../Redux/HomeSlice";
import { searsh_product } from "../Redux/HomeSlice";

import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useState, useEffect } from "react";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Loader from "../Loader";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Register from "../Register/Register";

import {
  get_cart,
  myProfile,
  add_wishlist,
  remove_wishlist,
  product_reviews,
  delete_cart,
  recommended,
  total_cart,
  product_details,
} from "../Redux/API";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { useTranslation } from "react-i18next";

function BuyNow() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const BuyNow = useSelector((state) => state?.products?.BuyNow);
  console.log(BuyNow)

  useEffect(() => {
    dispatch(recommended());  

    dispatch(total_cart());
  }, [dispatch]);

  const loadingDelete_cart = useSelector(
    (state) => state?.Data.loadingDelete_cart
  );

  const getLocalStorage = window.localStorage.getItem("UserInfo");
  const valueLocalStorage = getLocalStorage
    ? JSON.parse(getLocalStorage)
    : null;
  const token = valueLocalStorage?.data?.token || null;

  const showR = useSelector((state) => state?.products?.showR);
  const get_carts = useSelector((state) => state.Data.get_cart);
  const total_carts = useSelector((state) => state.Data.total_cart);
  const loadingGet_cart = useSelector((state) => state.Data.loadingGet_cart);
  const loadingTotal_cart = useSelector(
    (state) => state.Data.loadingTotal_cart
  );

  useEffect(() => {
    dispatch(get_cart());
  }, [dispatch, loadingDelete_cart]);

  useEffect(() => {
    dispatch(total_cart());
  }, [dispatch, loadingDelete_cart]);

  const [counter, setCounter] = useState(1);

  const increment = () => {
    setCounter((prevCounter) => prevCounter + 1);
  };

  const decrement = () => {
    setCounter((prevCounter) => (prevCounter > 1 ? prevCounter - 1 : 1));
  };

  const wishlist = useSelector(
    (state) => state?.Data?.myProfile?.data?.data?.user?.wishlist || []
  );
  const loadingRemove_wishlist = useSelector(
    (state) => state?.Data.loadingRemove_wishlist
  );
  const loadingAdd_wishlist = useSelector(
    (state) => state?.Data.loadingAdd_wishlist
  );

  useEffect(() => {
    if (!loadingRemove_wishlist && !loadingAdd_wishlist) {
      dispatch(myProfile());
    }
  }, [dispatch, loadingRemove_wishlist, loadingAdd_wishlist]);

  const handelAdd_wishlist = (id) => {
    if (token) {
      const isInWishlist = wishlist.some((item) => item.id === id);

      if (isInWishlist) {
        dispatch(remove_wishlist({ id }));
      } else {
        dispatch(add_wishlist({ id }));
      }
    } else {
      dispatch(showRegister(true));
    }
  };

  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
  const Sign_Up = (event) => {
    if (!token) {
      const { pageY } = event;
      const offsetY = -1200;
      setPopupPosition({ x: 50, y: pageY + offsetY });
      dispatch(showRegister(true));
    }
  };

  const recommendeds = useSelector((state) => state.Data.recommended);
  const loadingRecommended = useSelector(
    (state) => state.Data.loadingRecommended
  );
  const gotoProductDetails = (id) => {
    localStorage.setItem("Product_id", id);

    dispatch(product_details(id));
    dispatch(product_reviews(id));
    window.scrollTo(0, 0);
    navigate("/Product");
    dispatch(searsh_product(false));

  };
  const imagess1 = recommendeds?.data?.data || [];

  const [startIndex1, setStartIndex1] = useState(0);

  const handleNext1 = () => {
    if (startIndex1 + 5 < imagess1?.length) {
      setStartIndex1(startIndex1 + 1);
    }
  };

  const handlePrev1 = () => {
    if (startIndex1 > 0) {
      setStartIndex1(startIndex1 - 1);
    }
  };

  const getVisibleImages1 = () => {
    if (window.innerWidth >= 1400) {
      return imagess1?.slice(startIndex1, startIndex1 + 5);
    } else if (window.innerWidth >= 1200) {
      return imagess1?.slice(startIndex1, startIndex1 + 5);
    } else if (window.innerWidth >= 992) {
      return imagess1?.slice(startIndex1, startIndex1 + 4);
    } else if (window.innerWidth >= 768) {
      return imagess1?.slice(startIndex1, startIndex1 + 3);
    } else if (window.innerWidth >= 576) {
      return imagess1?.slice(startIndex1, startIndex1 + 3);
    } else {
      return imagess1?.slice(startIndex1, startIndex1 + 2);
    }
  };

  const delete_cartS = (id) => {
    console.log(id);
    dispatch(delete_cart(id));
  };

  const loadingSearsh_brand = useSelector(
    (state) => state.Data.loadingSearsh_brand
  );
  const show_searsh = useSelector((state) => state?.products?.searsh);
  const searsh = useSelector((state) => state.Data.searsh_brand);
  return (
    <div className="Purchasing">
            {showR && (
        <div className="overlay">
          <div
            className="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-4 mx-auto g-0"
            style={{
              position: "absolute",
              top: `${popupPosition.y}px`,
              left: "50%",
              transform: "translateX(-50%)",
              margin: "auto",
              zIndex: 4,
              padding: "0px",
            }}
          >
            <Register />
          </div>
        </div>
      )}

      <Header />

      {show_searsh && (
        <div className="searsh_product ">
          {loadingSearsh_brand && <Loader />}
          <div className="container offers">
            <div className="cont row justify-content-between g-0 border-0">
              <div className="col">
                <div className="gallery1 container 0 border-0">
                  <div className="row_prodect row align-items-center justify-content-around g-0 border-0">
                    {searsh?.data?.data.map((product, index) => {
                      const isInWishlist = wishlist.some(
                        (item) => item.id === product.id
                      );

                      return (
                        <div
                          key={index}
                          className="box col-5 col-sm-4 px-sm-2 col-md-4 px-md-3 col-lg-3 px-lg-3 mx-lg-0 col-xl-2 mx-xl-1 px-xl-0 text-center g-0 mb-3"
                        >
                          <div className="border_box">
                            <div className="padding_box">
                              <i
                                className="font-size2"
                                onClick={(event) =>
                                  handelAdd_wishlist(product.id, event)
                                }
                                style={{
                                  color: isInWishlist ? "red" : "white",
                                }}
                              >
                                <FontAwesomeIcon icon={faHeart} />
                              </i>
                              {product?.discount && (
                                <p className="discount">
                                  {t("off")} {product?.discount}
                                </p>
                              )}
                              <img
                                src={product.main_image}
                                alt={`img-${index}`}
                                onClick={() => gotoProductDetails(product.id)}
                              />
                              <span className="discraptoin mb-4 product_name ">
                                {product?.name}
                              </span>
                              <p className="discraptoin discraptoin_name">
                                {product?.type?.name}
                              </p>
                              <div className="price align-items-center">
                                <p>{product?.new_price}</p>
                                {product?.old_price && (
                                  <p className="old_price">
                                    {product?.old_price}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {loadingDelete_cart && <Loader />}
      {loadingGet_cart && <Loader />}
      <div className="container_Purchasing container mt-m-2">
        {/* {[BuyNow].map((e) => ( */}
          <div
            className="container_prodects row justify-content-between"
            key={BuyNow?.id}
          >
            <div className="col-12 col-md-6 col-lg-4 text-center">
              <img src={BuyNow?.main_image} alt="product" />
            </div>
            <div className="details col-12 col-md-6 col-lg-4">
              <p>{BuyNow?.nike}</p>
              <p>{t("color")}</p>
              <div className="d-flex">
                <div className="img_color">
                  <img src={BuyNow?.color} alt="color" />
                </div>
              </div>
              <p className="mt-3">{t("size")}</p>
              <div className="d-flex">
                <div className="img_color d-flex">
                  <span>{BuyNow?.size}</span>
                </div>
              </div>
            </div>
            <div className="box_counter col-12 col-md-6 col-lg-4 mt-sm-3 text-center">
              <div className="counter">
                <span className="span1" onClick={decrement}>
                  -
                </span>
                <span className="span3">{BuyNow?.quantity}</span>
                <span className="span2" onClick={increment}>
                  +
                </span>
              </div>
              <i>
                <FontAwesomeIcon
                  icon={faTrash}
                  onClick={() => delete_cartS(BuyNow?.id)}
                />
              </i>
              <p>
                <span>KWD</span>
                {BuyNow?.new_price}
              </p>
            </div>
          </div>
        {/* ))} */}
      </div>

      <div className="Vouchers container">
        <div className="row justify-content-end">
          <div className="Quantity col col-md-7 col-lg-6">
            <div>
              <p>{t("total_quantity")}</p>
              <p className="p2">2</p>
              <p>{t("total_price")}</p>
              <p className="p3">
                <span>KWD</span> {total_carts?.data.data.total}
              </p>
            </div>

            <div className="Promos2">
              <span>{t("discount_voucher")}</span>
              <span className="Discount">
                -<span className="KWD">KWD</span>
                {total_carts?.data.data.discount}
              </span>
            </div>
            <div className="Promos2">
              <span>{t("shipping_fee")}</span>
              <span>
                <span className="KWD">KWD</span>
                {total_carts?.data.data.shipping}
              </span>
            </div>
            <div className="Promos">
              <span>{t("total_price")}</span>
              <span>
                <span className="KWD border-0">KWD</span>
                {total_carts?.data.data.total}
              </span>
            </div>
            <div>{t("checkout_now")}</div>
            <div>{t("payment_methods")}</div>
            <div>ggggggggggggggg</div>

          </div>
        </div>
      </div>

      <div className="container">
        <p>{t("new_customers")}</p>
      </div>

      <div className="gallery1 container">
        {loadingRecommended && <Loader />}

        <div className="col-1 text-center icon2">
          <img src={icon9} className="iconLeft" onClick={handlePrev1} />
        </div>
        <div className="row align-items-center justify-content-between g-0">
          {getVisibleImages1().map((product, index) => {
            const isInWishlist = wishlist.some(
              (item) => item.id === product.id
            ); // تحقق من وجود المنتج في الوشليست

            return (
              <div
                className="box col-6 px-3 col-sm-4 px-sm-2 col-md-4 px-md-3 col-lg-3 col-xl-2 px-xl-0 mx-xl-0 text-center"
                key={index}
              >
                <div className="border_box">
                  <div className="padding_box">
                    <i
                      onClick={() => {
                        handelAdd_wishlist(product.id);
                      }}
                      style={{ color: isInWishlist ? "red" : "white" }} // تغيير لون الأيقونة
                    >
                      <FontAwesomeIcon icon={faHeart} />
                    </i>
                    {product?.discount && (
                      <p className="discount">Off {product?.discount}</p>
                    )}
                    {product?.main_image && (
                      <img
                        onClick={() => gotoProductDetails(product.id)}
                        src={product?.main_image}
                        alt={`img-${index}`}
                      />
                    )}
                    <p className="discraptoin">{product?.description}</p>
                    <div className="price align-items-center">
                      <p>{product?.new_price}</p>
                      {product?.old_price && (
                        <p className="old_price">{product?.old_price}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="col-1 text-center icon2">
          <img src={icon9} className="iconRitgh" onClick={handleNext1} />
        </div>
      </div>

      <Footer Sign_Up={Sign_Up} />
    </div>
  );
}

export default BuyNow;
